import { Injectable } from '@angular/core';
import { stringify } from 'querystring';
import { inititalSortFilter } from '@entity/enquiry';
import { tblPaginator } from '@entity/user-role';

@Injectable({
  providedIn: 'root'
})
export class PrimengTableService {
  constructor() { }

  public gridOptions: any = {
    first: 0,
    rows: 10,
    sortField: 'EnqId',
    sortOrder: -1
  };
  public event: any = {
    first: 0,
    rows: 10
  };

  onSort(e, gridOptions, localText) {
    gridOptions.sortField = e ? e.multisortmeta ? e.multisortmeta[0].field : e.field : '';
    gridOptions.sortOrder = e ? e.multisortmeta ? e.multisortmeta[0].order : e.order : '';
    gridOptions.first = 0;
    sessionStorage.setItem('existSort-' + localText, JSON.stringify(gridOptions));
  }

  onFilter(e, localText) {
    sessionStorage.setItem("filtersValue-" + localText, JSON.stringify(e));
    let event = {
      first: 0,
      rows: 10
    };
    let totalRecords = e.filteredValue.length;

    return this.OnPaginate(event, totalRecords, localText);
  }

  OnPaginate(event, totalRecords, localText) {
    let first = event.first;
    let currentPageNumber = ((event.first / tblPaginator.addNoOfRows) + tblPaginator.addPageNumber);
    let totalPages = (totalRecords / tblPaginator.addNoOfRows);
    let currentPageStart = (event.first + tblPaginator.addPageNumber);
    let currentPageEnd = (currentPageStart + tblPaginator.addPageEnd);
    currentPageEnd = totalRecords < currentPageEnd ? totalRecords : currentPageEnd;//pagination end record
    let paginationRecord = 'Displaying page ' + currentPageNumber + ' of ' + Math.ceil(totalPages) + ', records ' + currentPageStart + ' to ' + currentPageEnd + ' of ' + totalRecords + ' records.';
    let paginate = {
      first: first,
      paginationRecord: paginationRecord,
      totalRecords: totalRecords
    }
    sessionStorage.setItem("paginate-" + localText, JSON.stringify(paginate));
    return paginate;
  }

  initialSortAndFilter(dataTable, gridOptions, localText: String, totalRecords?: number, isArchive = false): inititalSortFilter {
    let filterValue;
    let filterText;
    let exitTotalRecords = totalRecords;
    let pagination;
    let existSort = sessionStorage.getItem('existSort-' + localText);    //sorting
    let existFilter = sessionStorage.getItem('filtersValue-' + localText);//filter
    let existPaginate = sessionStorage.getItem('paginate-' + localText);//paginate
    const sort = JSON.parse(existSort);
    const filter = JSON.parse(existFilter);
    const paginate = JSON.parse(existPaginate);
    if (sort || filter || (paginate || !paginate)) {
      if (sort) {
        gridOptions = sort;
        dataTable.sortField = gridOptions.sortField;
        dataTable.sortOrder = gridOptions.sortOrder;
        dataTable.sortSingle();
        // this.dt.paginator(this.gridOptions);
      }
      if (filter && filter.filters && filter.filters.global && filter.filters.global.value) {
        filterText = filter.filters ? filter.filters.global ? filter.filters.global.value : '' : '';
        totalRecords = filter.filteredValue ? filter.filteredValue.length : '';
        dataTable.filterGlobal(filterText, 'contains');
      }
      if (paginate && ((!isArchive && paginate.totalRecords == exitTotalRecords) || (isArchive))) {//existing pagination        
        this.event.first = paginate.first;//replace current value to existing pagination
        pagination = this.OnPaginate(this.event, exitTotalRecords, localText)
      }
      else if (!pagination && totalRecords) {//default pagination
        this.event.first = 0;
        pagination = this.OnPaginate(this.event, totalRecords, localText)
      }
      filterValue = {
        filterText: filterText,
        first: pagination ? pagination.first : 0,
        paginationRecord: pagination ? pagination.paginationRecord : ''
      }
      return filterValue;
    }
  }
}

